import { ComplexTable } from '@synergy/table';
import { Col, Row } from "antd";
import i18next from "i18next";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAuthContext } from "../../contexts/AuthContext";
import query from '../../server/constants.api';
import logger from "../../server/server";
import useFetch from "../../server/useFetch";
import { PageContent, PageSection, PageTitle } from "../../styles/global/Pages.styled";
import { Text } from "../Global/Atomics/Text";

export const Register = () => {
    const { t } = useTranslation(); // Translation hook
    const { user, tenant } = useAuthContext();
    const [fetchedData, setFetchData] = useState(null); // State for fetched data
    logger.info('User ' + user?.Username + ' accessed  Register page! Tenant: ' + tenant);

    const { data: registryData, isLoading: registryIsLoading, refetch: refetchRegistryData
    } = useFetch('/items', 'getRegistryData', {
        // types: 'Buildings',
        tenant: tenant,
    }, null, null, query.middlewareURL); // Custom hook for fetching complex table data

    const customInput = {
        placeholder: t('search'),
    }

    // Effect to refetch table data when language changes
    useEffect(() => {
        try {
            refetchRegistryData();
        } catch (error) {
            // logger.error('Error in useEffect refetchTableComplex');//LOG
            console.error('(Register page) Error in useEffect refetchTableComplex:', error);
            //reportError(error); // Send error report to backend
            logger.error('(Register page) User: ' + user?.Username + ' Tenant: ' + tenant + ', Error in useEffect refetchTableComplex:', error);
        }
    }, [i18next.resolvedLanguage])

    useEffect(() => {
        try {
            if (registryData) {
                setFetchData(registryData);
            }
        } catch (error) {
            // logger.error('Error in useEffect if exists data setFetchData');//LOG
            console.error('(Register page) Error in useEffect if exists data setFetchData:', error);
            //reportError(error); // Send error report to backend
            logger.error('(Register page)  User: ' + user?.Username + ' Tenant: ' + tenant + ', Error in useEffect if exists data setFetchData:', error);
        }
    }, [registryData])

    return (
        <PageContent id='registerTable' $backgroundColor='white' >
            <PageSection>
                <Row gutter={[32, 32]} style={{ width: '99%' }}>
                    <Col span={24}>
                        <PageTitle>
                            <div className="title">
                                <Text $fontColor='coolgray-12' $fontSize='text_xl' $weight='regular' $marginRight='s03'>
                                    {t('Assets')} </Text>
                            </div>
                        </PageTitle>
                    </Col>
                    <Col span={24}>
                        {/* addFunction={()=> navigate('/home/register/registerDetail/')} */}
                        <ComplexTable fetchData={fetchedData} hrefLink='/registry/building/' customInput={customInput} pagination={{ pageSize: 8 }} language={i18next.resolvedLanguage} isLoading={registryIsLoading} tableId='buildingsAssets' />
                    </Col>
                </Row>

            </PageSection>
        </PageContent >
    )
}